import React, { Component } from 'react'
import styles from './PlaceComments.scss'
import PlaceCommentRowContainer from '../PlaceCommentRowContainer'
import { withTranslation } from '@hocs'
import { imageAssetUrl } from '@libs/appUrl'

class PlaceComments extends Component {
  render() {
    const { totalCommentsCount, displayCommentIds, t } = this.props
    return (
      <div className="comments">
        <style jsx>{styles}</style>
        <div className="comments__header">
          <span>{t('相關評論')}</span>
          <span>{`${totalCommentsCount}${t('則評論')}`}</span>
        </div>
        {totalCommentsCount === 0 && (
          <div className="comments__emptyContainer">
            <img className="comments__emptyIcon" src={imageAssetUrl('nocomment.svg')} />
            <p className="comments__emptyText">{t('place.comments.empty')}</p>
          </div>
        )}
        <div className="comments__list">
          {displayCommentIds.map((commentId) => (
            <PlaceCommentRowContainer commentId={commentId} key={commentId} />
          ))}
        </div>
        {this.props.hasMoreComments && (
          <div className="comments__loadMore" onClick={this.props.expandPlaceComments}>
            <div className="comments__loadMoreButton">
              <span>{t('展開全部評論')}</span>
              <span className="comments__loadMoreIcon icon icon--arrowBottom" />
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation(['common'])(PlaceComments)
